import createCrud from './crud';
import modules from './budgets/index'


export default createCrud({
    resource: 'budgets',modules
  });